module.exports = __webpack_public_path__ + "media/images/home/occupation-82657feae37f9964a37ee4aca70f0632.png";